module.exports = __webpack_public_path__ + "img/nutts.e9d19b11.jpg";